export default __webpack_public_path__ + "static/media/rug3-min.f61f28b6.jpg";